import { LegalPage } from "./LegalPage";

const SECTIONS = [
  {
    title: "Tjänsten",
    text: "Studentflyttarna utför flyttjänster för studenter och privatpersoner med bas i Umeå, bland annat sträckorna Umeå–Östersund, Umeå–Sundsvall och Umeå–Luleå.",
  },
  {
    title: "Offert och bokning",
    text: "En offertförfrågan via hemsidan är kostnadsfri och inte bindande. En bokning blir bindande först när vi bekräftat den skriftligt via e-post.",
  },
  {
    title: "Priser och betalning",
    text: "Du får alltid fast pris i förväg – inga dolda kostnader. Vid utplacering via skolan skickas fakturan direkt till ditt universitet eller din region enligt bidragsbeslutet. Privatpersoner får 30 % RUT-avdrag direkt på fakturan, och vi sköter administrationen med Skatteverket.",
  },
  {
    title: "Av- och ombokning",
    text: "Av- och ombokning är kostnadsfritt. Hör av dig så snart du vet att något ändrats – vi är vana vid att anpassa oss efter universitetens utplaceringsbesked.",
  },
  {
    title: "Ansvar och försäkring",
    text: "Vi har ansvarsförsäkring som täcker din egendom under hela flytten och transporten. Eventuella skador ska anmälas till oss så snart som möjligt efter avslutad flytt.",
  },
  {
    title: "Studentpaket och presentkort",
    text: "Studenter med utplacering via skolan får ett presentkort värt 1 000 kr hos IKEA, Hemtex eller Cervera. Presentkortet kan inte lösas in mot kontanter och delas ut i mån av tillgång.",
  },
  {
    title: "Kontakt",
    text: "Studentflyttarna (Josef Muhammed), Umeå · kontakt@studentflyttarna.se · 070-727 29 41.",
  },
];

export default function TermsOfService() {
  return <LegalPage testid="terms-page" eyebrow="Juridik" title="Användarvillkor" updated="september 2026" sections={SECTIONS} />;
}
